import { render, staticRenderFns } from "./Protestos.vue?vue&type=template&id=0f64f701&scoped=true"
import script from "./Protestos.vue?vue&type=script&lang=js"
export * from "./Protestos.vue?vue&type=script&lang=js"
import style0 from "./Protestos.vue?vue&type=style&index=0&id=0f64f701&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f64f701",
  null
  
)

export default component.exports